
export type SearchUsers400 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
